import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import ReactSelect from '../ReactSelect';
import { defaultPageSizeOptions, DOTS, usePageSizeSelectOptions } from './pagination.contants';
import { Components as PaginationComponents } from './pagination.style';
import { usePagination } from './usePagination';
const PaginationV2 = props => {
  const {
    className = 'pagination',
    totalPages,
    currentPage = 1,
    visiblePages = 10,
    previousLabel = 'Previous',
    nextLabel = 'Next',
    ariaLabel = 'Navigate pages',
    fit = 'medium',
    disabledTruncation = false,
    onPageChange,
    hidePageSizeOptions,
    hiddenLabels = false,
    onPageSizeOptionsChange,
    pageSizeOptions = defaultPageSizeOptions,
    variant = 'default',
    menuPlacement = 'auto',
    defaultSelectedValue,
    disableSelect = false
  } = props;
  const pageSizeSelectOptions = usePageSizeSelectOptions(pageSizeOptions);
  const filteredOption = pageSizeSelectOptions.filter(item => item.value === (defaultSelectedValue === null || defaultSelectedValue === void 0 ? void 0 : defaultSelectedValue.toString()));
  const createNewOption = Object.keys(filteredOption).length ? filteredOption[0] : {
    label: defaultSelectedValue + '',
    value: defaultSelectedValue + ''
  };
  const defaultOption = defaultSelectedValue ? createNewOption : pageSizeSelectOptions[0];
  const [selectedPageSize, setSelectedPageSize] = useState(defaultOption);
  const handleNavButtonClick = type => {
    if (!isChangingPagePossible(type)) return;
    const currentPageval = type === 'prev' ? currentPage - 1 : currentPage + 1;
    onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(currentPageval);
  };
  const handlePageButtonClick = page => {
    if (currentPage === page) return;
    onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(page);
  };
  const isChangingPagePossible = type => {
    return type === 'prev' && currentPage !== 1 || type === 'next' && currentPage !== totalPages || !hidePageSizeOptions;
  };
  const buildPageButton = page => {
    const isCurrentPage = currentPage === page;
    return _jsx(PaginationComponents.Item, {
      children: _jsx(PaginationComponents.PaginationButton, {
        label: page.toString(),
        variant: "".concat(isCurrentPage ? 'filled' : 'plain'),
        ariacurrent: isCurrentPage,
        arialabel: isCurrentPage ? "Current Page, Page ".concat(page) : "Go to Page ".concat(page),
        fit: fit,
        id: "pagination-button-".concat(page),
        onClick: () => handlePageButtonClick(page)
      })
    }, page);
  };
  const renderNavButton = name => {
    const buttonlabel = name === 'prev' ? previousLabel : nextLabel;
    const disabled = name === 'prev' ? currentPage === 1 : currentPage === totalPages || totalPages < 1;
    const icon = name === 'prev' ? 'chevron-left' : 'chevron-right';
    const iconposition = name === 'next' ? 'right' : 'left';
    return _jsx(PaginationComponents.Item, {
      children: _jsx(PaginationComponents.PaginationButton, {
        label: !hiddenLabels ? buttonlabel : undefined,
        variant: "plain",
        disabled: disabled,
        icon: icon,
        iconPosition: iconposition,
        fit: fit,
        id: "pagination-".concat(name),
        onClick: () => handleNavButtonClick(name === 'prev' ? 'prev' : 'next')
      })
    });
  };
  const buildEllipsis = index => {
    return _jsx(PaginationComponents.Item, {
      children: _jsx(PaginationComponents.Link, _extends({
        "aria-label": "ellipsis",
        fit: fit,
        variant: "disabled"
      }, {
        children: DOTS
      }))
    }, "ellipsis-".concat(index));
  };
  const onPageSizeSelection = newValue => {
    onPageSizeOptionsChange === null || onPageSizeOptionsChange === void 0 ? void 0 : onPageSizeOptionsChange(+(newValue === null || newValue === void 0 ? void 0 : newValue.value));
    onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(1);
    setSelectedPageSize(newValue);
  };
  const paginationRange = usePagination({
    totalPages,
    visiblePages,
    currentPage,
    disabledTruncation
  });
  return _jsxs(PaginationComponents.Nav, _extends({
    role: "navigation",
    "aria-label": ariaLabel,
    className: className
  }, {
    children: [_jsxs(PaginationComponents.List, {
      children: [renderNavButton('prev'), paginationRange.map((pageNumber, index) => {
        return pageNumber === DOTS ? buildEllipsis(index) : buildPageButton(Number(pageNumber));
      }), renderNavButton('next')]
    }), !hidePageSizeOptions && (pageSizeSelectOptions === null || pageSizeSelectOptions === void 0 ? void 0 : pageSizeSelectOptions.length) && _jsx(PaginationComponents.Select, {
      children: _jsx(ReactSelect, {
        menuPlacement: menuPlacement,
        options: pageSizeSelectOptions,
        name: 'pageSize',
        id: 'pageSize',
        placeholder: "Select",
        label: 'Rows per page',
        value: [selectedPageSize],
        fit: fit,
        onChange: onPageSizeSelection,
        variant: variant,
        disabled: disableSelect
      })
    })]
  }));
};
export default PaginationV2;